function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 2");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "path-1-invoice",
  cx: 58.8,
  cy: 58.8,
  r: 58.8
}), React.createElement("circle", {
  id: "path-3-invoice",
  cx: 58.8,
  cy: 58.8,
  r: 58.8
}), React.createElement("linearGradient", {
  x1: "22.760771%",
  y1: "-11.6496836%",
  x2: "65.4176892%",
  y2: "86.3220189%",
  id: "linearGradient-5-invoice"
}, React.createElement("stop", {
  stopColor: "#F49593",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#F7BF28",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "114.735974%",
  y1: "-13.0235412%",
  x2: "21.4106793%",
  y2: "85.1020665%",
  id: "linearGradient-6-invoice"
}, React.createElement("stop", {
  stopColor: "#F09724",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E81C69",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "89.3236703%",
  y1: "47.9439292%",
  x2: "21.409691%",
  y2: "51.748932%",
  id: "linearGradient-7-invoice"
}, React.createElement("stop", {
  stopColor: "#7E2889",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#1587C8",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "89.3236703%",
  y1: "49.8053424%",
  x2: "21.409691%",
  y2: "50.1655794%",
  id: "linearGradient-8-invoice"
}, React.createElement("stop", {
  stopColor: "#7E2889",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#1587C8",
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-invoice",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "07-desktop-UI-invoice",
  transform: "translate(-396.000000, -314.000000)"
}, React.createElement("g", {
  id: "Group-2-invoice",
  transform: "translate(396.000000, 314.000000)"
}, React.createElement("mask", {
  id: "mask-2-invoice",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1-invoice"
})), React.createElement("use", {
  id: "Mask-invoice-invoice",
  fill: "#F1F1F1",
  fillRule: "nonzero",
  xlinkHref: "#path-1-invoice"
}), React.createElement("mask", {
  id: "mask-4-invoice",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-3-invoice"
})), React.createElement("g", {
  id: "Mask-Copy-invoice",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "Group-invoice",
  mask: "url(#mask-4-invoice)"
}, React.createElement("g", {
  transform: "translate(60.915409, 78.178515) rotate(11.000000) translate(-60.915409, -78.178515) translate(27.915409, 33.678515)"
}, React.createElement("rect", {
  id: "Rectangle-31-invoice",
  fill: "url(#linearGradient-5-invoice)",
  fillRule: "nonzero",
  x: -8.18545232e-12,
  y: 0,
  width: 65.1,
  height: 88.2
}), React.createElement("rect", {
  id: "Rectangle-32-invoice",
  fill: "url(#linearGradient-6-invoice)",
  fillRule: "nonzero",
  x: 4.9,
  y: 6.3,
  width: 10.5,
  height: 9.8,
  rx: 4.9
}), React.createElement("rect", {
  id: "Rectangle-32-Copy-invoice",
  fill: "url(#linearGradient-7-invoice)",
  fillRule: "nonzero",
  x: 42.7,
  y: 9.1,
  width: 16.8,
  height: 3.5,
  rx: 1.75
}), React.createElement("rect", {
  id: "Rectangle-32-Copy-2-invoice",
  fill: "url(#linearGradient-7-invoice)",
  fillRule: "nonzero",
  x: 42.7,
  y: 15.4,
  width: 16.8,
  height: 3.5,
  rx: 1.75
}), React.createElement("path", {
  d: "M6.65,64.4 L57.75,64.4 C58.7164983,64.4 59.5,65.1835017 59.5,66.15 C59.5,67.1164983 58.7164983,67.9 57.75,67.9 L6.65,67.9 C5.68350169,67.9 4.9,67.1164983 4.9,66.15 C4.9,65.1835017 5.68350169,64.4 6.65,64.4 Z",
  id: "Rectangle-32-Copy-8-invoice-invoice",
  fill: "url(#linearGradient-8-invoice)",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M6.65,70.7 L57.75,70.7 C58.7164983,70.7 59.5,71.4835017 59.5,72.45 C59.5,73.4164983 58.7164983,74.2 57.75,74.2 L6.65,74.2 C5.68350169,74.2 4.9,73.4164983 4.9,72.45 C4.9,71.4835017 5.68350169,70.7 6.65,70.7 Z",
  id: "Rectangle-32-Copy-7-invoice-invoice",
  fill: "url(#linearGradient-8-invoice)",
  fillRule: "nonzero"
}), React.createElement("g", {
  id: "Group-3-invoice",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(10.500000, 30.100000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "Orion_flame-Copy-invoice",
  transform: "translate(20.639394, 0.000000)",
  stroke: "#204386",
  strokeWidth: 1.4
}, React.createElement("path", {
  d: "M19.3030303,5.46 C16.1318182,8.2355 16.5454545,12.74 16.5454545,12.74 C16.5454545,12.74 11.8575758,5.6875 13.7878788,0 C11.9035354,3.822 3.67676768,4.823 7.35353535,15.47 C2.71161616,13.741 2.75757576,8.19 2.75757576,8.19 C2.75757576,8.19 -9.09494702e-13,10.92 -9.09494702e-13,16.38 C-9.09494702e-13,22.4109494 4.93843494,27.2999998 11.030303,27.2999998 C17.1221711,27.2999998 22.0606061,22.4109494 22.0606061,16.38 C22.0606061,10.829 18.0621212,10.8745 19.3030303,5.46 Z",
  id: "Shape-invoice"
})), React.createElement("g", {
  id: "Orion_plug-Copy-invoice",
  transform: "translate(-0.000000, 0.000000)",
  stroke: "#204386",
  strokeWidth: 1.4
}, React.createElement("path", {
  d: "M9.97676768,20.3 L9.97676768,23.94 L6.3,23.94 L6.3,20.3 M8.13838384,23.9855 L8.13838384,27.58",
  id: "Shape-invoice-invoice"
}), React.createElement("path", {
  d: "M14.7070707,7.28 L14.7070707,15.47 C14.7070707,16.676735 14.2228549,17.8340453 13.3609453,18.6873359 C12.4990357,19.5406264 11.3300354,20.02 10.1111111,20.02 L6.43434343,20.02 C3.89606504,20.02 1.83838384,17.9828956 1.83838384,15.47 L1.83838384,7.28 M-9.09494702e-13,7.28 L16.5454545,7.28 M4.5959596,7.28 L4.5959596,0 M11.9494949,7.28 L11.9494949,0",
  id: "Shape-invoice"
}))))))));

var SvgInvoice = function SvgInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 118 118",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invoice.6d671976.svg";
export { ForwardRef as ReactComponent };